import { SHOWBY_OPTIONS } from '@constants/common/chart/chartConst';
import RadioButtons from '@lib/inputs/RadioButtons';
import React from 'react';
import { useIntl } from 'react-intl';
import { SegmentByContainer, FieldsetResetStyle, LegendStyle } from './styles';
import { Label } from 'semantic-ui-react';


interface IShowByProps {
    showBy: string;
    setShowBy: Function;
    isDrillDownActive: boolean;
    isTagFilterApplied: boolean;
}

function ShowBy(props: IShowByProps) {
    const { showBy, setShowBy, isDrillDownActive } = props;
    const intl = useIntl();

    return (
        <SegmentByContainer as="fieldset" className="--segment-by" style={FieldsetResetStyle}>
            <Label as="legend" style={LegendStyle}>{intl.formatMessage({id:'reports.label.showBy'})}</Label>
            <RadioButtons
                label={{
                    showRequiredIcon: false,
                    labelClass: [''],
                    ulClass: [''],
                    isLabelVisible: false,
                }}
                inputData={{
                    id: 'showBy',
                    isInputRequired: true,
                    type: 'radio',
                    options: SHOWBY_OPTIONS,
                    value: showBy,
                    liClass: ['text-left'],
                    disabled: isDrillDownActive,
                }}
                legend={{
                    dataInstructions: false,
                }}
                inputActions={{
                    handleFieldChange: value => setShowBy(value),
                }}
            />
        </SegmentByContainer>
    );
}

export default ShowBy;
